module.exports = __webpack_public_path__ + "img/groups-application-requests-unactive.f8ec92c.svg";